
















































































import { Vue, Prop, Component } from "vue-property-decorator";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";

@Component({ components: {} })
export default class ListenerTableItem extends Vue {
  @Prop() listener!: ICourseListener;
  @Prop() courseId!: string;
  data() {
    return {};
  }

  get screenWidth() {
    return window.innerWidth;
  }
}
